import { useContext, useEffect } from 'react';
import { LoggedUserContext } from 'contexts';

const LogoutPage = () => {
  const { logout } = useContext(LoggedUserContext);

  useEffect(() => {
    logout();
  });

  return null;
};

export default LogoutPage;
